import { useDispatch, useSelector } from "react-redux"
import { cleanGeneralDetail } from "./GeneralDetailSlice"
import { Box, Button, Modal, ModalDialog, Stack, Textarea, Typography } from "@mui/joy"

function GeneralDetailsDialog() {
    var msg = useSelector((state) => state.generalDetail.msg)
    var dispatch = useDispatch()
    var close = () => {
        dispatch(cleanGeneralDetail())
    }

    return msg == null ? "" :
        <Modal open={true} onClose={close}>
            <ModalDialog
                aria-labelledby="basic-modal-dialog-title"
                aria-describedby="basic-modal-dialog-description"
                sx={{ minWidth: 800 }}
            >
                <Typography id="basic-modal-dialog-title" component="h2">
                    Detalhes
                </Typography>
                <Textarea value={msg} minRows={10} style={{overflowY: "auto", overflowX: "hidden"}}/>
            </ModalDialog>
        </Modal>
}

export default GeneralDetailsDialog